<!--
  ~ Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->
<form class="form" [formGroup]="userDetailsFormGroup" (ngSubmit)="saveUser()" input-template>
  <div>
    <mat-form-field class="form__input" [color]="'primary'">
      <input
        matInput
        placeholder="First Name*"
        name="firstName"
        formControlName="firstName"
        (change)="updateUser()"
      />
    </mat-form-field>
    <mat-form-field class="form__input" [color]="'primary'">
      <input
        matInput
        placeholder="Last Name*"
        name="lastName"
        formControlName="lastName"
        (change)="updateUser()"
      />
    </mat-form-field>
    <mat-form-field class="form__input" [color]="'primary'">
      <input
        matInput
        type="email"
        placeholder="Email*"
        name="email"
        formControlName="email"
        (change)="updateUser()"
      />
    </mat-form-field>
    <mat-form-field class="form__input" [color]="'primary'">
      <input
        matInput
        type="url"
        placeholder="Profile Picture Url"
        name="picture"
        formControlName="picture"
        (change)="updateUser()"
      />
    </mat-form-field>
    <mat-form-field class="form__input" [color]="'primary'">
      <input
        matInput
        placeholder="JIRA ID"
        name="issueKey"
        formControlName="issueKey"
        [required]="isApprovalIdRequired"
      />
    </mat-form-field>
  </div>

  @if (!loading) {
  <div>
    @if (enableFormCancel) {
    <button mat-icon-button (click)="cancelForm()">
      <i class="material-icons">cancel</i>
    </button>
    }
    <button mat-icon-button type="submit">
      <i class="material-icons">save</i>
    </button>
  </div>
  } @if (loading) {
  <div class="form__loading">
    <mat-progress-spinner
      [mode]="'indeterminate'"
      [color]="'primary'"
      [diameter]="40"
    ></mat-progress-spinner>
  </div>
  }
</form>
